package one.healthium.bland.presentation.feature.launch

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import ifaandroid.apps.bland.composeapp.generated.resources.Res
import ifaandroid.apps.bland.composeapp.generated.resources.brand
import ifaandroid.apps.bland.composeapp.generated.resources.ic_splash
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource

@Composable
actual fun LaunchScreen() {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Image(
            modifier = Modifier.size(100.dp),
            painter = painterResource(Res.drawable.ic_splash),
            contentDescription = null,
        )
        Image(
            modifier = Modifier
                .offset(y = -(60.dp))
                .align(Alignment.BottomCenter),
            painter = painterResource(Res.drawable.brand),
            contentDescription = null,
        )
    }
}

@Composable
@Preview(showBackground = true)
private fun LaunchScreenPreview() {
    AppTheme {
        LaunchScreen()
    }
}